import {
  ButtonsWrapper,
  DateAndTimeWrapper,
  DateMainContainer,
  DateSlider,
  DateSliderContainer,
  DateSliderTrack,
  DaysWrapper,
  TimeMainContainer,
  TimeSlider,
  TimeSliderContainer,
  TimeSliderTrack,
  TimeWrapper
} from './ScheduleContentOrder.styled';
import { useEffect, useState } from 'react';

import { Anchor } from '../../../shared';
import { ScheduleDay } from './ScheduleDay';
import { ScheduleTime } from './ScheduleTime';
import { retreiveBranchStoreScheduleProccessOrder } from '../../../api/branchStores';
import { useTranslation } from 'next-i18next';

interface ScheduleContentProps {
  branchStoreId: number;
  setProgrammedTime: (time: string) => void;
  closeSchedule: (isClosed: boolean) => void;
  handleProcessNow: () => void;
}

interface Schedule {
  [key: string]: { start: string; end: string }[];
}

export const ScheduleContentOrder = ({ branchStoreId, setProgrammedTime, closeSchedule, handleProcessNow }: ScheduleContentProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [orderSchedule, setOrderSchedule] = useState<Schedule>({});
  const [selectedDay, setSelectedDay] = useState('');
  const [selectedHour, setSelectedHour] = useState('');

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    retreiveBranchStoreScheduleProccessOrder({ id: branchStoreId })
      .then(schedule => {
        if (isMounted && Object.keys(schedule).length) {
          const firstElem = Object.keys(schedule)[0];
          setOrderSchedule(schedule);
          setSelectedDay(firstElem);
          setSelectedHour(schedule[firstElem][0].start);
        }
      })
      .catch((error) => {
        throw new Error(error);
      })
      .finally(() => {
        if (isMounted) {
          setLoading(false);
        }
      });

    return () => { isMounted = false; };
  }, [branchStoreId]);

  const handleProgrammedTime = () => {
    setProgrammedTime(selectedHour);
    setLoading(false);
    closeSchedule(true);
  };

  const handleCloseSchedule = () => {
    handleProcessNow();
    closeSchedule(true);
  };

  if (loading) {
    return <div>{t('ScheduleOrder.loadingSchedule.title')}</div>;
  }

  return (
    <DateAndTimeWrapper>
      <DateMainContainer>
        <DateSlider>
          <DateSliderContainer>
            <DateSliderTrack>
              <DaysWrapper>
                {Object.keys(orderSchedule).map((date) => (
                  <ScheduleDay
                    key={date}
                    date={date}
                    selectedDay={selectedDay}
                    setDay={(selected) => {
                      setSelectedDay(selected);
                      setSelectedHour(orderSchedule[selected][0].start);
                    }}
                  />
                ))}
              </DaysWrapper>
            </DateSliderTrack>
          </DateSliderContainer>
        </DateSlider>
      </DateMainContainer>

      <TimeMainContainer>
        <TimeSlider>
          <TimeSliderContainer>
            <TimeSliderTrack>
              <TimeWrapper>
                {orderSchedule[selectedDay]?.map((timeSlot, index) => (
                  <ScheduleTime
                    key={index}
                    startTime={timeSlot.start}
                    endTime={timeSlot.end}
                    selectedTime={selectedHour}
                    setTime={setSelectedHour}
                  />
                ))}
              </TimeWrapper>
            </TimeSliderTrack>
          </TimeSliderContainer>
        </TimeSlider>
      </TimeMainContainer>

      <ButtonsWrapper>
        <Anchor
          title={t('ScheduleOrder.CtaprogramOrder.title')}
          size='medium'
          variation='secondary'
          onClick={handleProgrammedTime}
        />
        <Anchor
          title={t('ScheduleOrder.CtaCancelprogramOrder.title')}
          size='medium'
          variation='secondary'
          onClick={handleCloseSchedule}
        />
      </ButtonsWrapper>
    </DateAndTimeWrapper>
  );
};
